import periodicity from './periodicity'

const plans = {
  periodicity,
}

export default plans
